import {
  HomeIcon,
  TagIcon,
  CubeIcon,
  UsersIcon,
  ArchiveBoxIcon,
  BanknotesIcon,
  DocumentChartBarIcon,
  PlusCircleIcon,
  BuildingOfficeIcon,
  ServerIcon,
  Cog6ToothIcon,
  ChartBarIcon,
  GiftIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";

export const navigation = [
  { name: "Home", href: "/", icon: HomeIcon, current: true },
  {
    name: "Raw Item Masters",
    icon: TagIcon,
    current: false,
    children: [
      { name: "Brand Master", href: "/brandmaster", permission: "MOD_BRAND" },
      { name: "Sub Brand Mast", href: "/subbrandmaster", permission: "MOD_SUBBRAND" },
      { name: "RAW-Item Master", href: "/itemmaster", permission: "MOD_RAW_ITEM" },
      { name: "Size Master", href: "/sizemaster", permission: "MOD_SIZE" },
      { name: "Shape Master", href: "/shapemaster", permission: "MOD_SHAPE" },
      { name: "Colour Master", href: "/colormaster", permission: "MOD_COLOR" },
      { name: "Size Group Master", href: "/size-grouping-master", permission: "MOD_SIZE_GROUP" },
      { name: "Unit Master", href: "/unitmaster", permission: "MOD_UNIT" },
      { name: "UOM Conversion", href: "/uomconversion", permission: "MOD_UOM_CONV" },
      { name: "Credit/Debit Note Types", href: "/cndntypes", permission: "MOD_CNDN_TYPES" },
      { name: "Area Master", href: "/areamaster", permission: "MOD_AREA" },
    ]
  },
  {
    name: "Main Item Masters",
    icon: CubeIcon,
    current: false,
    children: [
      { name: "Item Master(Bulk)", href: "/item-master-bulk", permission: "MOD_ITEM_BULK" },
      { name: "Pack Ratio", href: "/packratio", permission: "MOD_PACK_RATIO" },
      { name: "Pricelist Master", href: "/pricelist", permission: "MOD_PRICELIST" },
      { name: "Pricelist Detail", href: "/pricelistdetail", permission: "MOD_PRICELIST" },
      { name: "Order Print Group", href: "/order-print-group", permission: "MOD_ORDER_PRINT_GROUP" },
      { name: "Discount Masters", href: "/discount-masters", permission: "MOD_DISCOUNT" },
    ]
  },
  {
    name: "Account Masters",
    icon: UsersIcon,
    current: false,
    children: [
      { name: "Vend/Cust Groups", href: "/groups", permission: "MOD_PARTY_GROUP" },
      { name: "GL Accounts Master", href: "/gl-accounts-master", permission: "MOD_GL_ACCOUNTS" },
      { name: "Opening Balances", href: "/opening-balances", permission: "MOD_OPN_BAL" },
      { name: "Profiling Master", href: "/profiling-master", permission: "MOD_PROFILING" },
    ]
  },
  {
    name: "Inventory",
    icon: ArchiveBoxIcon,
    current: false,
    children: [
      { name: "Orders", href: "/order", permission: "MOD_ORDER" },
      { name: "Order Recon", href: "/order-reconciliation", permission: "MOD_ORDER_RECON" },
      { name: "Shipping Info", href: "/shippinginfo", agentOnly: true, permission: "MOD_SHIPPING" },
      { name: "Sale Challan", href: "/shippinginfo?traderbilltyp=S", traderOnly: true, permission: "MOD_SHIPPING" },
      { name: "Purchase Challan", href: "/shippinginfo?traderbilltyp=P", traderOnly: true, permission: "MOD_SHIPPING" },
      { name: "Sale Bill", href: "/salebill", agentOnly: true, permission: "MOD_SALEBILL" },
      { name: "Sale Bill", href: "/salebill?traderbilltyp=S", traderOnly: true, permission: "MOD_SALEBILL" },
      { name: "Purchase Bill", href: "/salebill?traderbilltyp=P", traderOnly: true, permission: "MOD_SALEBILL" },
      { name: "Credit/Debit Note", href: "/cndn", permission: "MOD_CNDN" },
    ]
  },
  {
    name: "Accounts",
    icon: BanknotesIcon,
    current: false,
    children: [
      { name: "Voucher Master", href: "/voucher-master", traderOnly: true, permission: "MOD_VOUCHER" },
      { name: "Money Receipt", href: "/voucher-master?type=MR", permission: "MOD_MONEY_RECEIPT" },
      { name: "Journal Voucher", href: "/voucher-master?type=JR", permission: "MOD_JOURNAL" },
      { name: "Cash Receipt", href: "/voucher-master?type=CC", traderOnly: true, permission: "MOD_VOUCHER" },
      { name: "Cash Payment", href: "/voucher-master?type=CD", traderOnly: true, permission: "MOD_VOUCHER" },
      { name: "Bank Receipt", href: "/voucher-master?type=BC", traderOnly: true, permission: "MOD_VOUCHER" },
      { name: "Bank Payment", href: "/voucher-master?type=BD", traderOnly: true, permission: "MOD_VOUCHER" },
      { name: "Covering Letter", href: "/cvletter", permission: "MOD_CV_LETTER" },
      { name: "Payment Recon", href: "/paymentrecon", permission: "MOD_PAYMENT_RECON" },
      { name: "Due Reminder", href: "/due-reminder", permission: "MOD_DUE_REMINDER" },
    ]
  },
  {
    name: "Reports",
    icon: DocumentChartBarIcon,
    current: false,
    children: [
      {
        name: "Inventory Reports",
        children: [
          { name: "Item List", href: "/reports/inventory/item-list", permission: "MOD_REP_INV_ITEM_LIST" },
          { name: "Stock Reports", href: "/reports/inventory/stock", permission: "MOD_REP_INV_ITEM_LIST" },
          { name: "Order History", href: "/reports/inventory/order-history", permission: "MOD_REP_INV_ORDER_HIST" },
          { name: "Order Register", href: "/reports/inventory/order-register?reportof=G&formtp=ORD", permission: "MOD_REP_INV_ORDER_REG" },
          { name: "Pending Order", href: "/reports/inventory/pending-order", permission: "MOD_REP_INV_PEND_ORDER" },
          { name: "Salebill Register", href: "/reports/inventory/salebill-register?reportof=G&formtp=BILL", permission: "MOD_REP_INV_BILL_REG" },
          { name: "Debit Note Register", href: "/reports/inventory/debit-note-register?reportof=VDN&formtp=VDN", permission: "MOD_REP_INV_DN_REG" },
          { name: "Credit Note Register", href: "/reports/inventory/credit-note-register?reportof=VCN&formtp=VCN", permission: "MOD_REP_INV_CN_REG" },
        ]
      },
      {
        name: "Accounts Reports",
        children: [
          { name: "Opening Trail", href: "/reports/accounts/opening-trail?formtp=print", permission: "MOD_REP_ACC_OPN_TRAIL" },
          { name: "Journal Book", href: "/reports/accounts/journal-book", permission: "MOD_REP_ACC_JRNL" },
          { name: "Ledger", href: "/reports/accounts/ledger", permission: "MOD_REP_ACC_LEDGER" },
          { name: "Trail Balance", href: "/reports/accounts/trail-balance", permission: "MOD_REP_ACC_TRAIL_BAL" },
          { name: "Balance Sheet", href: "/reports/accounts/balance-sheet", traderOnly: true, permission: "MOD_REP_ACC_BAL_SHEET" },
          { name: "Profit & Loss", href: "/reports/accounts/profit-loss", traderOnly: true, permission: "MOD_REP_ACC_PROFIT_LOSS" },
        ]
      },
      { name: "Day Book", href: "/reports/accounts/day-book", permission: "MOD_REP_ACC_DAY_BOOK" },
      { name: "Payment Due Aging", href: "/reports/accounts/payment-due-aging", permission: "MOD_REP_ACC_AGING" },
      { name: "Analysis (Items)", href: "/reports/accounts/analysis-items", permission: "MOD_REP_ACC_ANALYSIS" },
      { name: "Sales Report", href: "/reports/sales/agent-sales-analytics", permission: "MOD_REP_SALES" }
    ]
  },
  {
    name: "Scheme",
    icon: GiftIcon,
    current: false,
    children: [
      {
        name: "Masters",
        children: [
          { name: "Gift Items", href: "/scheme-gift-items", permission: "MOD_SCH_GIFT" },
          { name: "Scheme Master", href: "/scheme-master", permission: "MOD_SCH_MASTER" },
          { name: "Scheme Detail", href: "/scheme-detail-edit", permission: "MOD_SCH_DETAIL" },
        ]
      },
      {
        name: "Transactions",
        children: [
          { name: "Issue / Order", href: "/scheme-issue", permission: "MOD_SCH_ISSUE" },
          { name: "Order Reconciliation", href: "/scheme-order-recon", permission: "MOD_SCH_ORDER_RECON" },
        ]
      },
      {
        name: "Reports",
        children: [
          { name: "Scheme Print", href: "/reports/scheme/print", permission: "MOD_REP_SCH_PRINT" },
          { name: "Eligibility Summary", href: "/reports/scheme/eligibility-summary", permission: "MOD_REP_SCH_ELIG_SUM" },
          { name: "Eligibility Detail", href: "/reports/scheme/eligibility-detail", permission: "MOD_REP_SCH_ELIG_DTL" },
          { name: "Pending Orders", href: "/reports/scheme/pending-orders", permission: "MOD_REP_SCH_PEND" },
        ]
      },
    ]
  },
  {
    name: "Plus",
    icon: PlusCircleIcon,
    current: false,
    children: [
      { name: "Document Viewer", href: "/document-viewer", permission: "MOD_DOC_VIEWER" },
      { name: "Mail Tracker", href: "/mail-tracker", permission: "MOD_MAIL_TRACKER" },
      { name: "Messages", href: "/messages" },
    ]
  },
];

export const userNavigation = [
  { name: "Your profile", href: "#" },
  { name: "Sign out", href: "#" },
];

export const superAdminNavigation = [
  {
    name: "Companies",
    href: "/super-admin/companies",
    icon: BuildingOfficeIcon,
  },
  {
    name: "Database Management",
    href: "/super-admin/databases",
    icon: ServerIcon,
  },
  {
    name: "System Settings",
    href: "/super-admin/settings",
    icon: Cog6ToothIcon,
  },
  {
    name: "Analytics",
    href: "/super-admin/analytics",
    icon: ChartBarIcon,
  },
  {
    name: "HSN Management",
    href: "/super-admin/hsn",
    icon: DocumentTextIcon,
  },
];

export const superAdminUserNavigation = [
  { name: "Sign out", href: "#" },
];
